import type { SVGProps } from 'react';

type CheckIconProps = SVGProps<SVGSVGElement>;

const CheckIcon = (props: CheckIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={6}
        height={6}
        viewBox="0 0 6 5"
        fill="none"
        {...props}
    >
        <path
            d="M0.75 2.25L2.25 3.75L5.25 0.75"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default CheckIcon;